import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from './routes';

/**
 * The configured browser router instance. Created once at module load so
 * that history, cache, and matches survive re-renders of any consumer.
 */
const router = createBrowserRouter(routes);

/**
 * Top-level component that mounts the data router.
 * Kept as a small wrapper so `app.jsx` stays declarative and testable.
 */
const AppRouter = () => <RouterProvider router={router} />;

export { router, routes };
export default AppRouter;
